import React from "react";
import { IoCalendar } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import EASkeletonLoader from "../../../shared/EASkeletonLoader";
import useReservationsList from "./useReservationsList";
import SingleReservation from "./SingleReservation";
import EAButton from "../../../shared/Buttons/EAButton";
import EmptyStateContainer from "./EmptyStateContainer";
import ListExpandControls from "../ListExpandControls";
import useParentMessage from "../../../../../utils/hooks/useParentMessage";

const ReservationsList = () => {
  const { t } = useTranslation();
  const { scrollToTop } = useParentMessage();
  const {
    upcomingReservations,
    pastReservations,
    loading,
    showPastReservation,
    setShowPastReservation,
    refreshTickets,
    displayedUpcomingCount,
    setDisplayedUpcomingCount,
    displayedPastCount,
    setDisplayedPastCount,
    ITEMS_PER_PAGE,
  } = useReservationsList();

  const handleUpcomingCollapseAll = () => {
    setDisplayedUpcomingCount(ITEMS_PER_PAGE);
    scrollToTop();
  };

  const handlePastCollapseAll = () => {
    setDisplayedPastCount(ITEMS_PER_PAGE);
    scrollToTop();
  };

  if (loading) {
    return <EASkeletonLoader height="120px" />;
  }

  return (
    <div className="list-container">
      <span className="text-size-body-large text-color-primary text-icon-align-center">
        <IoCalendar /> <b>{t("nadchodzące")}</b>
      </span>
      <div className="list-wrapper">
        {upcomingReservations.length > 0 ? (
          <>
            {upcomingReservations.slice(0, displayedUpcomingCount).map((reservation, index) => (
              <SingleReservation
                key={index}
                ticket={reservation.ticket}
                exercise={reservation.exercise}
                onRefreshTickets={refreshTickets}
              />
            ))}
            {(displayedUpcomingCount < upcomingReservations.length || displayedUpcomingCount > ITEMS_PER_PAGE) && (
              <ListExpandControls
                displayedCount={displayedUpcomingCount}
                totalCount={upcomingReservations.length}
                setDisplayedCount={setDisplayedUpcomingCount}
                itemsPerPage={ITEMS_PER_PAGE}
                showMoreLabelKey="pokaz_wiecej"
                onCollapseAllAndScrollTop={handleUpcomingCollapseAll}
              />
            )}
          </>
        ) : (
          <EmptyStateContainer />
        )}
      </div>

      <span className="text-size-body-large text-color-dark-gray text-icon-align-center">
        <IoCalendar /> <b>{t("przeszłe")}</b>
      </span>
      {showPastReservation ? (
        <div className="list-wrapper">
          {pastReservations.length > 0 ? (
            <>
              {pastReservations.slice(0, displayedPastCount).map((reservation, index) => (
                <SingleReservation
                  key={index}
                  ticket={reservation.ticket}
                  exercise={reservation.exercise}
                  onRefreshTickets={refreshTickets}
                />
              ))}
              {(displayedPastCount < pastReservations.length || displayedPastCount > ITEMS_PER_PAGE) && (
                <ListExpandControls
                  displayedCount={displayedPastCount}
                  totalCount={pastReservations.length}
                  setDisplayedCount={setDisplayedPastCount}
                  itemsPerPage={ITEMS_PER_PAGE}
                  showMoreLabelKey="pokaz_starsze"
                  onCollapseAllAndScrollTop={handlePastCollapseAll}
                />
              )}
            </>
          ) : (
            <p style={{ textAlign: "center", color: "var(--primary-color500)" }}>{t("brak_przeszlych_rezerwacji")}</p>
          )}
        </div>
      ) : (
        <EAButton
          title={t("Pokaż historię rezerwacji")}
          variant="text"
          color="primary"
          onClick={() => setShowPastReservation(!showPastReservation)}
        />
      )}
    </div>
  );
};

export default ReservationsList;
